const mapping: Record<string, string> = {
  id: 'b=>b.Id',
  name: 'b=>b.Name',
  tribuneId: 'b=>b.TribuneId',
  type: 'b=>b.Type',
  code: 'b=>b.Code',
}

export const mapSortBlockParam = (key: string) => mapping[key]
